import { z } from "zod";

export namespace CommonDto {
  export const withStatus = <T extends z.ZodType<any, any, any>>(schema: T) =>
    z.object({
      status: z.string(),
      data: schema,
      details: z.string().optional()
    });

  export const ApiError = z.object({
    details: z.string()
  });

  export type ApiError = z.infer<typeof ApiError>;

  export type WithStatus<T extends z.ZodType<any, any, any>> = z.infer<
    ReturnType<typeof withStatus<T>>
  >;
}
